"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var Headline_1 = tslib_1.__importDefault(require("./Headline"));
var HeadlineTransformationUtils_1 = require("./utils/HeadlineTransformationUtils");
var noop_1 = tslib_1.__importDefault(require("lodash/noop"));
/**
 * The React component that handles the transformation of the execution objects into the data accepted by the {@link Headline}
 * React component that this components wraps. It also handles the propagation of the drillable items to the component
 * and drill events out of it.
 */
var HeadlineTransformation = /** @class */ (function (_super) {
    tslib_1.__extends(HeadlineTransformation, _super);
    function HeadlineTransformation(props) {
        var _this = _super.call(this, props) || this;
        _this.handleFiredDrillEvent = _this.handleFiredDrillEvent.bind(_this);
        return _this;
    }
    HeadlineTransformation.prototype.render = function () {
        var _a = this.props, intl = _a.intl, drillableItems = _a.drillableItems, dataView = _a.dataView, config = _a.config, onAfterRender = _a.onAfterRender;
        var data = HeadlineTransformationUtils_1.getHeadlineData(dataView, intl);
        var drillablePredicates = sdk_ui_1.convertDrillableItemsToPredicates(drillableItems);
        var dataWithUpdatedDrilling = HeadlineTransformationUtils_1.applyDrillableItems(data, drillablePredicates, dataView);
        var disableDrillUnderline = this.getDisableDrillUnderlineFromConfig();
        return (react_1.default.createElement(Headline_1.default, { data: dataWithUpdatedDrilling, config: config, onDrill: this.handleFiredDrillEvent, onAfterRender: onAfterRender, disableDrillUnderline: disableDrillUnderline }));
    };
    HeadlineTransformation.prototype.getDisableDrillUnderlineFromConfig = function () {
        if (this.props.config) {
            return this.props.config.disableDrillUnderline;
        }
    };
    HeadlineTransformation.prototype.handleFiredDrillEvent = function (item, target) {
        var _a = this.props, onDrill = _a.onDrill, dataView = _a.dataView;
        var drillEventData = HeadlineTransformationUtils_1.buildDrillEventData(item, dataView);
        sdk_ui_1.fireDrillEvent(onDrill, drillEventData, target);
    };
    HeadlineTransformation.defaultProps = {
        drillableItems: [],
        onDrill: function () { return true; },
        onAfterRender: noop_1.default,
    };
    return HeadlineTransformation;
}(react_1.default.Component));
exports.default = react_intl_1.injectIntl(HeadlineTransformation);
//# sourceMappingURL=HeadlineTransformation.js.map